import { styled } from '@mui/material/styles';
import { Link } from 'common/components/material';

export const CommonStyledLink = styled(Link)(({ theme, color }) => ({
  color: (color as string) || theme.palette.LinkText.Default,
  '&:hover': {
    color: theme.palette.LinkText.Active,
  },
}));
